var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgU2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 32,
    viewBox: "0 0 102 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 26.3125C1 26.3125 4.57194 25.2175 14.75 21.625C24.9281 18.0325 26 31 26 31C26 31 30.3912 12.2395 33.5 14.125C36.6088 16.0105 39.5851 16.0105 41 14.125C42.4149 12.2395 41.0372 18.8125 46 18.8125C50.9628 18.8125 50.5215 13.5116 52.25 10.375C53.9785 7.23842 56.5262 11.4784 61 14.125C65.4738 16.7716 68.5213 30.0264 69.75 28.1875C70.9787 26.3486 72.0027 17.875 74.75 17.875C77.4973 17.875 77.472 4.75 79.75 4.75C82.028 4.75 82.7494 17.4413 86 17.4413C89.2506 17.4413 91.0932 1.93986 93.5 1.93986C95.9068 1.93986 101 1 101 1V31H1V26.3125Z",
    fill: "url(#paint0_linear_1295_1060)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 26.3125C1 26.3125 4.57194 25.2175 14.75 21.625C24.9281 18.0325 26 31 26 31C26 31 30.3912 12.2395 33.5 14.125C36.6088 16.0105 39.5851 16.0105 41 14.125C42.4149 12.2395 41.0372 18.8125 46 18.8125C50.9628 18.8125 50.5215 13.5116 52.25 10.375C53.9785 7.23842 56.5262 11.4784 61 14.125C65.4738 16.7716 68.5213 30.0264 69.75 28.1875C70.9787 26.3486 72.0027 17.875 74.75 17.875C77.4973 17.875 77.472 4.75 79.75 4.75C82.028 4.75 82.7494 17.4413 86 17.4413C89.2506 17.4413 91.0932 1.93986 93.5 1.93986C95.9068 1.93986 101 1 101 1",
    stroke: "#42A93C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1295_1060",
    x1: 1.21281,
    y1: 1,
    x2: 1.21281,
    y2: 30.8723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42A93C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42A93C",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU2);
export default __webpack_public_path__ + "static/media/U2.7d17da23cbf99e05b6c481e2891a7ded.svg";
export { ForwardRef as ReactComponent };